import { render, staticRenderFns } from "./GuestVideoRoom.vue?vue&type=template&id=c9885100"
import script from "./GuestVideoRoom.vue?vue&type=script&lang=ts"
export * from "./GuestVideoRoom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports